import EventQnASection from './partials/EventQnASection';
import ElokuvaPage from './partials/ElokuvaPage';
import EventCalendarActions from './partials/EventCalendarActions';
import { livestreamCategoryLabel } from '../config/livestreamConstants';
import { roomLabel } from '../config/virtualRooms';
import { useT } from '../i18n/I18nModule';

function formatEventDay(eventDate) {
  if (!eventDate || !/^\d{4}-\d{2}-\d{2}$/.test(eventDate)) return '—';
  const [y, m, d] = eventDate.split('-').map((x) => parseInt(x, 10));
  const dd = String(d).padStart(2, '0');
  const mm = String(m).padStart(2, '0');
  const now = new Date();
  const currentYear = now.getFullYear();
  let out = `${dd}. ${mm}.`;
  if (y !== currentYear) out += ` ${y}`;
  const todayStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = tomorrow.getFullYear() + '-' + String(tomorrow.getMonth() + 1).padStart(2, '0') + '-' + String(tomorrow.getDate()).padStart(2, '0');
  if (eventDate === todayStr) out += ' (Tänään)';
  else if (eventDate === tomorrowStr) out += ' (Huomenna)';
  return out;
}

export default function EventView({ event: ev, onBack, user }) {
  const t = useT();
  const isOwner = user && ((ev?.createdByUserId != null && String(ev.createdByUserId) === String(user.id)) || (ev?.author === (user.displayName || user.username)));

  if (!ev) return null;

  const levyraatiPlaylistRaw = ev.levyraati_playlist ?? ev.levyraatiPlaylist;
  const durationStr = ev.minutes != null ? (ev.minutes >= 60 ? `${ev.minutes / 60} h` : `${ev.minutes} min`) : '—';

  return (
    <div className="EventView App-block">
      <div className="EventView-header-actions">
        <button type="button" className="Button EventView-back" onClick={onBack}>
          ←
        </button>
      </div>
      
      <h2>{ev.title || 'TAPAHTUMA'}</h2>


      <div className={`event-card${isOwner ? ' -edit' : ''}`}>
          {ev.eventType === 'movie' ? (
            <ElokuvaPage event={ev} />
          ) : (
            <dl className="EventView-dl">
              <dt>Kuvaus</dt>
              <dd>
                {ev.description || '—'}
              </dd>

              <dt>Alkaa</dt>
              <dd>{ev.time || '—'}</dd>

              <dt>Pvm</dt>
              <dd>{formatEventDay(ev.eventDate)}</dd>

              <dt>Kesto</dt>
              <dd>{durationStr}</dd>

              <dt>Luonut</dt>
              <dd>{ev.author || '—'}</dd>

              <dt>Tapahtuman tyyppi</dt>
              <dd>
                {ev.eventType === 'levyraati'
                  ? 'Levyraati'
                  : ev.eventType === 'livestream'
                    ? `Livestriimi (${ev.livestreamType === 'talk' ? 'puhe' : 'musiikki'})`
                    : ev.embedUrl
                      ? 'striimi'
                      : ev.gameType && ev.gameType !== 'none'
                        ? 'peli'
                        : ev.eventType || '—'}
              </dd>

              {ev.eventType === 'livestream' && (
                <>
                  <dt>{ev.livestreamType === 'talk' ? 'Kieli' : 'Genre'}</dt>
                  <dd>{livestreamCategoryLabel(ev.livestreamType, ev.livestreamCategory)}</dd>
                </>
              )}

              <dt>Virtuaalihuone</dt>
              <dd>{t('event.room')} {ev.roomNumber ?? 1}</dd>

              {isOwner && ev.livestreamIngestUrl && (
                <>
                  <dt>Lähetys-URL</dt>
                  <dd>
                    {ev.streamPublishActive ? (
                      <code className="EventView-stream-url">{ev.livestreamIngestUrl}</code>
                    ) : (
                      <span>Aktivoituu 10 min ennen alkua</span>
                    )}
                  </dd>
                </>
              )}
              {ev.livestreamPlaybackPageUrl && (
                <>
                  <dt>Katsojien striimi</dt>
                  <dd>
                    <a href={ev.livestreamPlaybackPageUrl} className="EventView-link" target="_blank" rel="noopener noreferrer">
                      {ev.livestreamPlaybackPageUrl}
                    </a>
                    {ev.id && (ev.streamPlaybackActive || ev.streamWindow?.playbackActive) ? (
                      <>
                        {' '}
                        <a href={`/event/stream/${ev.id}`} className="EventView-link">
                          Liity striimiin sovelluksessa
                        </a>
                      </>
                    ) : null}
                  </dd>
                </>
              )}

              {!isOwner && ev.eventType === 'levyraati' && (
                <>
                  <dt>Biisejä</dt>
                  <dd>{Array.isArray(levyraatiPlaylistRaw) ? levyraatiPlaylistRaw.length : '—'}</dd>
                </>
              )}

              {ev.embedUrl && (
                <>
                  <dt>URL</dt>
                  <dd>
                    <a
                      href={ev.embedUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="EventView-link"
                    >
                      {ev.embedUrl}
                    </a>
                  </dd>
                </>
              )}
            </dl>
          )}

        <EventQnASection event={ev} user={user} />
        <EventCalendarActions event={ev} />
      </div>
    </div>
  );
}
